
import { Vue, Component, Prop } from "vue-property-decorator";
import { SmartSVG, SVGLibraryCustom } from "_components";
import { createModifierClass } from "_utils";

@Component({
  name: "HomeHeroAlternativeArrowButton",
  components: { SmartSVG },
})
export default class HomeHeroAlternativeArrowButton extends Vue {
  @Prop({ type: Boolean, default: false }) isLeft!: boolean;
  @Prop({ type: Boolean, default: false }) isHidden!: boolean;
  @Prop({ type: Boolean, default: false }) isMob!: boolean;

  rootClass = "c-home-hero-alternative-button";
  icon = SVGLibraryCustom.PQArrowRightBreadcrumbs;

  get svgStyle() {
    return this.isLeft ? { transform: "rotate(180deg)" } : {};
  }

  get wrapperClass() {
    return [
      this.rootClass,
      ...createModifierClass(this.rootClass, this.isMob, "is-mob"),
      ...createModifierClass(this.rootClass, this.isHidden, "is-hidden"),
    ];
  }
}
